import {
  API_BASE_URL,
  GET_COMMONGROUND,
  POST_COMMONGROUND,
  AUTH_TOKEN_KEY
} from '../constants';

import fetch from '../utils/Api';

export const getCommonGround = () => ({
  type: GET_COMMONGROUND,
  payload: fetch({
    Authorization: 'Bearer '+localStorage.getItem(AUTH_TOKEN_KEY)
  }).get(`${API_BASE_URL}/raffles/2`)
    .then(res => {
      return res.data
    })
  })

export const submitCommonGround = (payload) => ({
  type: POST_COMMONGROUND,
  payload: fetch({
    Authorization: 'Bearer ' +localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .post(`/raffles`, payload)
  .then(res => {
    return res.data
  })
})